module.exports = "data:image/gif;base64,R0lGODlhBwAHAPAAAP////CDACH5BAUAAAAALAAAAAAHAAcAAAIKhBF5qJexnpyUFgA7"


//////////////////
// WEBPACK FOOTER
// ./static/img/dajiao.gif
// module id = 2RvN
// module chunks = 1